module.exports = __webpack_public_path__ + "static/media/rupee.a0a45dcb.svg";